// Action Types

export const Types = {
  SET: 'param/SET'
};

// Reducer
const initialState = {
  cocFilterBoxOpenned: false,
  sidebarOpenned: true,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.SET:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

// Action Creators
export function setParam(param) {
  return {
    type: Types.SET,
    payload: {
      ...param
    }
  };
}
